import Vue from 'vue'
//import Store from './vuex/store'
import Router from 'vue-router'
//import Utilities from './utilities'
import Homepage from '@/components/views/homepage'
import Concorsi from '@/components/views/concorsi'
import Regali from '@/components/views/regali'
import Incentive from '@/components/views/incentive'
import Loyalty from '@/components/views/loyalty'
import Welfare from '@/components/views/welfare'
import Blufreccia from '@/components/views/blufreccia'
import NotFound from '@/components/views/not-found'


const Post = () => import(/* webpackChunkName: "post-chunk" */'./components/views/blog/post')
  .then(function(Post) {
    window.console.log('async: Post View loaded')
    return Post
  })

const BlogHomeCategory = () => import(/* webpackChunkName: "publics-chunk" */'@/components/views/blog/blog-home-category')
  .then(function(BlogHomeCategory) {
    window.console.log('async: BlogHomeCategory View loaded')
    return BlogHomeCategory
  })


Vue.use(Router)

let router = new Router({
    mode: process.env.VUE_APP_ROUTER_MODE,
    /*
    scrollBehavior: function(to) {
      if(process.env.VUE_APP_ROUTER_MODE == 'history' && to.path.indexOf('#') > 0){
        return {selector: to.path.substr(to.path.indexOf('#'))}
      }else{
        return {selector: '#app'}
      }
    },*/    
    scrollBehavior (to, from, savedPosition) {
        if (savedPosition) {
          return savedPosition
        } else {
          return { x: 0, y: 0 }
        }
    },   
    routes: [
        {
            path: '/concorsi-premi',
            name: 'concorsi',
            component: Concorsi,
        },   
        {
            path: '/regali-aziendali',
            name: 'regali',
            component: Regali,
        },   
        {
            path: '/viaggi-incentive',
            name: 'incentive',
            component: Incentive,
        },   
        {
            path: '/programmi-loyalty',
            name: 'loyalty',
            component: Loyalty,
        },
        {
            path: '/welfare-aziendale',
            name: 'welfare',
            component: Welfare,
        },
        {
            path: '/blufreccia',
            name: 'blufreccia',
            component: Blufreccia,
        },
        {
            path: '/',
            alias: ['/index.html'],
            name: 'homepage',
            component: Homepage,
        },
        {
          name: 'post',
          path: '/post/:postId/:title',
          component: Post,
          props: (route) => {
            const postId = Number.parseInt(route.params.postId, 10)
            if (Number.isNaN(postId)) {
              return 0
            }
            return { postId }
          },
        },
        {
            path: '/blog',
            name: 'blog',
            component: BlogHomeCategory,
            publicRoute: true, //custom attribute
            props: () => {
                return {
                    //categorySlug: 'consumer'
                }
            }
        },        
        /*{
          path: '/soluzioni-welfare',
          name: 'welfare',
          component: Welfare,
        },
        {
          path: '/metodi-pagamento',
          name: 'pagamento',
          component: Welfare,
        },
        */
        /* esempio con props passate da url
        {
            path: '/in-salabam/:inSalabamId/:inSalabamTitle',
            name: 'in-salabam',
            component: HomeInSalabam,
            publicRoute: true, //custom attribute
            props: true
        },
        */
        // gestisce i "404", !!! DEVE STARE PER ULTIMA !!!
        /*{
            path: '*',
            name: 'notFound',
            redirect: {name: 'homepage'},
            props: {
              prerenderStatusCode: '404',
            }
            //publicRoute: true, //custom attribute
        },*/
        {
          path: '*',
          name: 'not-found',
          component: NotFound,
          props: {
            prerenderStatusCode: '404',
          }
        },
    ]
})


router.beforeEach((to, from, next) => {    
    // se devo andare in manutenzione non controllare nient'altro: vai in manutenzinoe
    if (to.name == 'maintenance')
    {
        next()
        return
    }
    /*
    let route = router.options.routes.filter(function (r) {
        if(to.matched.length > 0)
        {
            return r.name == to.matched[0].name
        }
    })[0]
    */
    // altrimenti naviga as usual
    next()
})


router.afterEach((to) => {
    // per scrollare alle sezioni di id #id
    // bisogna gestirlo in parte manualmente
    // se hai già il sito caricato, i fragment funzionano
    // ma se arrivi da fuori con link con fragment, va gestito così
    if(to.hash && to.hash != ''){
        //if(process.env.VUE_APP_MODE != 'production') window.console.log('fragment found')
        // TODO fare interval 500, check element id != undefined, trigger
        setTimeout(function(){
            //if(process.env.VUE_APP_MODE != 'production') window.console.log('scrolling to ' + to.hash)
            document.getElementById(to.hash.substr(1)).scrollIntoView();
        }, 500); // setTimeout
    }
})


export default router